{
  "authentication": {
    "log_out": "Log Out"
  },
  "dashboard": {
    "title": "Dashboard",
    "language": "Language",
    "myApps": "My Apps",
    "sort": "Sort",
    "sortAZ": "Alphabetically A-Z",
    "sortZA": "Alphabetically Z-A",
    "noApplications": "No applications assigned to the user. Please coordinate with the admin.",
    "noSearchResults": "No applications match your search."
  },
  "header": {
    "searchPlaceholder": "Search",
    "userManagementSubtitle": "View and/or edit user roles.",
    "menu": {
      "userManagement": "User Management",
      "settings": "Profile Settings",
      "signOut": "Sign Out"
    }
  },
  "alerts": {
    "dismiss": "Dismiss alert",
    "successTitle": "Success",
    "errorTitle": "Error"
  },
  "authCallback": {
    "logLabel": "Auth0 callback error",
    "unknownErrorCode": "unknown",
    "referenceCode": "Reference code: {{code}}",
    "supportId": "Support ID: {{id}}",
    "tryAgain": "Try again",
    "logoAlt": {
      "wordmark": "Lucid",
      "bear": "Lucid bear logo"
    },
    "messages": {
      "emailVerification": "Please verify your email before continuing.",
      "passwordRotation": "Your password has expired. Please reset it.",
      "notEntitled": "You are not entitled to access this application.",
      "orgDisabled": "Your organization access has been disabled. Please contact your administrator.",
      "blockedUser": "Your account is blocked.",
      "invalidInvitation": "The invitation link is invalid or malformed. Please check the email and try again.",
      "expiredInvitation": "The invitation has expired. Please request a new invitation from your administrator.",
      "invitationAlreadyUsed": "This invitation has already been used. If you need to join the organization, please request a new invitation.",
      "generic": "Something went wrong. Please try again or contact support."
    },
    "recovery": {
      "emailVerification": "Check your inbox for a verification email, then try signing in again.",
      "passwordRotation": "Use the Forgot your password option on the login page, then try again.",
      "unauthorized": "Unauthorized action. Contact your administrator or support.",
      "invitationRetry": "Request a new invitation from your administrator and try again.",
      "generic": "Try signing in again. If the issue continues, contact support."
    }
  },
  "managementApi": {
    "errors": {
      "authenticate": "Unable to authenticate request. Please try again.",
      "network": "Unable to reach the server. Please try again.",
      "requestFailed": "Request failed ({{status}}). Please try again.",
      "responseParse": "Unable to process server response. Please try again.",
      "fetchFailed": "Fetch failed: {{status}}",
      "phoneNumberExists": "Phone Number is being used by another account"
    }
  },
  "profileSettings": {
    "title": "Account Settings",
    "subtitle": "View and/or edit user information.",
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save",
    "userProfile": {
      "sectionTitle": "User Profile",
      "firstName": "First Name",
      "middleName": "Middle Name",
      "middleNamePlaceholder": "Enter Middle Name",
      "lastName": "Last Name",
      "email": "Email",
      "changeEmailAddress": "Change Email Address",
      "changePhoneNumber": "Change Phone Number",
      "timeZone": "Time Zone",
      "phoneNumber": "Phone Number",
      "editPhoneNumberTitle": "Edit Phone Number",
      "editPhoneNumberDescription": "Add multiple phone numbers at your convenience, including a Primary phone number and additional phone numbers for your account. Your Primary phone number is one of the identifiers for your account. You can make changes to your phone numbers, including your Primary phone number, at any time.",
      "updatePrimaryContact": "Update Primary Contact",
      "updateError": "Failed to update your profile. Please try again.",
      "errors": {
        "firstNameRequired": "First name is required",
        "lastNameRequired": "Last name is required",
        "nameInvalid": "Only letters, spaces, hyphens, and apostrophes are allowed",
        "nameTooLong": "Name must be 255 characters or fewer",
        "timezoneRequired": "Time zone is required"
      }
    },
    "saveSuccessModal": {
      "title": "Account Updated",
      "message": "Your changes have been successfully updated.",
      "close": "CLOSE",
      "closeAria": "Close"
    },
    "mfaSettings": {
      "accordionTitle": "Multi-Factor Authentication",
      "description": "Add an extra layer of security to your account by enabling multi-factor authentication (MFA). Once enabled, you'll receive a one-time code by email to verify it's you whenever you log in from an unrecognized device. You can also add multiple authentication methods at your convenience, such as your preferred third-party authentication app or cell phone.",
      "defaultMethod": "Default Authentication Method",
      "manageMethod": "Manage Authentication Method",
      "manageDescription": "Add multiple authentication methods at your convenience, such as your preferred third-party authentication app or cell phone. You can make changes to your authentication methods at any time.",
      "stepUpAuthInfo": "For security purposes, the next step will require you to verify your identity through Step Up Authentication.",
      "addMethod": "Add Authentication Method",
      "defaultUneditableMethod": "Default (Uneditable)",
      "primaryContact": "Primary Contact",
      "primaryContactUpdated": "Primary contact has been updated.",
      "primaryContactUpdateError": "Failed to update primary contact. Please try again.",
      "methodRemoved": "Authentication method removed successfully.",
      "methodRemoveError": "Failed to remove authentication method. Please try again.",
      "method": {
        "email": "Email Authentication",
        "sms": "SMS Authentication",
        "totp": "Third Party App Authentication"
      },
      "editAction": {
        "prompt": "How would you like to update this authentication method?",
        "makePrimaryContact": "Make this my primary contact",
        "deleteNumber": "Delete this number",
        "delete": "Delete",
        "selectReplacementPrimary": "Which number would you like to set as your primary contact?",
        "confirm": "Confirm"
      }
    },
    "businessAddress": {
      "accordionTitle": "Business Address",
      "country": "Country",
      "locale": "Locale",
      "streetAddress1": "Street Address 1",
      "streetAddress1Placeholder": "Enter Street Address 1",
      "streetAddress2": "Street Address 2",
      "streetAddress2Placeholder": "Enter Apt or PO Box",
      "city": "City",
      "cityPlaceholder": "Enter City",
      "stateRegion": "State/Province/Region",
      "stateRegionPlaceholder": "Enter State/Province/Region",
      "zipCode": "Postal Code",
      "zipCodePlaceholder": "Enter Postal Code",
      "validationSuggestionTitle": "We found a suggested address:",
      "validationCorrectedLabel": "Corrected address:",
      "validationUseSuggested": "Use suggested address",
      "validationKeepMine": "Keep my address",
      "saveErrorTitle": "Something went wrong",
      "saveErrorMessage": "Failed to save your address. Please try again.",
      "errors": {
        "maxLength": "Maximum {{max}} characters allowed",
        "required": "This field is required",
        "invalidCharacters": "Only letters, numbers, spaces, and address punctuation (- . , ' / # &) are allowed"
      }
    },
    "changePassword": {
      "accordionTitle": "Password",
      "changePassword": "Change Password",
      "lastUpdated": "Last updated {{date}}"
    },
    "managePasskeys": {
      "accordionTitle": "Passkey",
      "addPasskey": "Add Passkey",
      "delete": "Delete",
      "addedOn": "Added on {{date}}",
      "lastUsed": "Last used {{date}}",
      "deleteModal": {
        "title": "Delete Passkey",
        "description": "Would you like to delete the following passkey?",
        "cancel": "Cancel",
        "confirm": "Delete Passkey",
        "done": "Done",
        "successMessage": "The passkey has been successfully deleted.",
        "deleteError": "Failed to delete passkey. Please try again."
      }
    }
  },
  "userManagement": {
    "table": {
      "searchPlaceholder": "Search user with name or email address",
      "columns": {
        "fullName": "Full Name",
        "role": "Role",
        "email": "Email",
        "phoneNumber": "Phone Number",
        "country": "Country",
        "locale": "Locale",
        "postalCode": "Postal Code",
        "status": "Status"
      },
      "statusValues": {
        "enrolled": "Enrolled",
        "invitePending": "Invite Pending",
        "inviteExpired": "Invite Expired"
      },
      "pagination": {
        "showingItems": "Showing {{start}}-{{end}} of {{total}} items",
        "pageOf": "{{current}} of {{total}}"
      }
    },
    "deleteUsers": "Delete",
    "makeAdmin": "Make admin",
    "confirm": "Confirm",
    "continue": "Continue",
    "makeAdminModal": {
      "title": "Grant Admin Access",
      "description": "Please confirm you with to grant Admin access to the following user(s):",
      "loadingText": "Please wait, assigning admin role",
      "makeAdminError": "Failed to assign admin role to selected user(s)"
    },
    "andMore": "and {{count}} more",
    "bulkActionLimit": "These actions can be performed on at most {{limit}} users at once",
    "deleteWarningBulkLimit": "Only {{limit}} users can be deleted at a time. Update your selection and try again.",
    "inviteWarningBulkLimit": "Only {{limit}} users can be invited at a time. Update your selection and try again.",
    "makeAdminWarningMultipleUsers": "Only {{limit}} user can be assigned as admin. Update your selection and try again.",
    "makeAdminWarningAlreadyAdmin": "Selected user is already an admin. Update your selection and try again.",
    "deleteModal": {
      "title": "Delete User(s)",
      "description": "Please confirm that you want to delete the following user(s):",
      "loadingText": "Please wait, deleting user(s)",
      "successDescription": "Successfully deleted the following user(s):",
      "cancel": "Cancel",
      "deleteError": "Failed to delete selected user(s)"
    },
    "selectedUsers": "Selected {{count}} User(s)",
    "userDetail": {
      "close": "Close",
      "lastModified": "Last Modified",
      "email": "Email",
      "phoneNumber": "Phone Number",
      "countryLocale": "Country/Locale",
      "postalCode": "Postal Code",
      "roleAssignment": "Role Assignment",
      "selectedRoles": "Selected {{count}} Role(s)",
      "searchRoles": "Search roles",
      "unselectAll": "Unselect All",
      "selectAll": "Select All",
      "roleName": "Role",
      "roleDescription": "Description",
      "cancel": "Cancel",
      "save": "Save",
      "badgeAdmin": "Admin",
      "badgeUser": "Standard User",
      "adminOnlyError": {
        "title": "Deletion Cannot Be Completed",
        "description": "{{name}} is an Admin. Please assign the Admin role to another user before proceeding with deletion."
      },
      "roleAdminOnlyError": {
        "title": "Role reassignment cannot be completed.",
        "description": "{{name}} is currently the only admin. Please assign the admin role to another user before unselecting the admin role for the current user."
      }
    },
    "edit": "Edit",
    "inviteModal": {
      "title": "Invite User(s)",
      "description": "Please enter user email(s) to invite. Separate email addresses with commas.",
      "confirmationDescription": "Please confirm invitation of the following users(s):",
      "inputLabel": "User Email(s)*",
      "inputPlaceholder": "Enter User Name",
      "invalidEmailFormat": "Please enter valid email address(es).",
      "loadingText": "Please wait, inviting user(s)",
      "inviteError": "Failed to send invitation(s)",
      "alreadyMembersError": "The following users are already members of the organization: {{emails}}"
    },
    "inviteUser": "Invite User",
    "roleChangeConfirmModal": {
      "title": "Role Change",
      "description": "Please confirm role changes to {{name}}'s profile:",
      "cancel": "Cancel",
      "confirm": "Confirm"
    }
  }
}
